import { render } from "./klb-ac.vue?vue&type=template&id=6138f78e&scoped=true"
import script from "./klb-ac.vue?vue&type=script&lang=js"
export * from "./klb-ac.vue?vue&type=script&lang=js"

import "./klb-ac.vue?vue&type=style&index=0&id=6138f78e&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6138f78e"]])

export default __exports__